import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PwaUpdateComponent } from './shared/components/pwa-update/pwa-update.component';
import { PwaInstallComponent } from './shared/components/pwa-install/pwa-install.component';
import { LanguageService } from './core/i18n/language.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, PwaUpdateComponent, PwaInstallComponent],
    standalone : true,
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Core Egypt';

  private readonly language = inject(LanguageService);

  constructor() {
    // Resolves the active language and sets <html lang> / <html dir> before the
    // first render, so an Arabic session never flashes an LTR layout.
    this.language.init();
  }
}
